"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _customPropTypes = _interopRequireDefault(require("../utils/customPropTypes"));

var _numbersDigitsToText = require("../utils/numbersDigitsToText");

var _translationHook = _interopRequireDefault(require("../utils/translationHook"));

var _excluded = ["ariaLabel", "currentStep", "dataTestId", "totalSteps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ProgressIndicator = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      currentStep = _ref.currentStep,
      dataTestId = _ref.dataTestId,
      totalSteps = _ref.totalSteps,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var progressStep = {
    EN: "You are currently on step ".concat(_numbersDigitsToText.englishNumbers[currentStep] || currentStep, " of ").concat(_numbersDigitsToText.englishNumbers[totalSteps] || totalSteps),
    ES: "Actualmente est\xE1 en paso ".concat(_numbersDigitsToText.spanishNumbers[currentStep] || currentStep, " de ").concat(_numbersDigitsToText.spanishNumbers[totalSteps] || totalSteps)
  };
  var translatedProgressStep = (0, _translationHook.default)(progressStep, [currentStep, totalSteps]);

  var ProgressSteps = function ProgressSteps() {
    var steps = [];

    for (var i = 1; i <= totalSteps; i += 1) {
      var isActive = i <= currentStep;
      var isCompleted = i < currentStep;
      var isCurrent = i === currentStep;
      var stepStatus = '';

      if (isCompleted) {
        stepStatus = 'completed';
      } else if (isCurrent) {
        stepStatus = 'current';
      } else {
        stepStatus = 'not completed';
      }

      steps.push( /*#__PURE__*/_react.default.createElement("svg", {
        className: (0, _classnames.default)('progress-indicator__step', {
          'progress-indicator__step--is-active': isActive
        }),
        width: "100%",
        height: "4",
        "aria-hidden": "true",
        "data-step-status": stepStatus,
        key: i
      }, /*#__PURE__*/_react.default.createElement("rect", {
        x: "0",
        width: "100%",
        height: "2",
        rx: "2"
      })));
    }

    return steps;
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "progress-indicator",
    role: "progressbar",
    "aria-label": ariaLabel,
    "aria-valuemin": "0",
    "aria-valuenow": currentStep,
    "aria-valuemax": totalSteps,
    "aria-valuetext": translatedProgressStep,
    "data-testid": dataTestId,
    ref: ref
  }, additionalProps), /*#__PURE__*/_react.default.createElement(ProgressSteps, null));
});
ProgressIndicator.displayName = 'ProgressIndicator';
ProgressIndicator.propTypes = {
  /**
   Optional. Customizes the aria-label value.
   */
  ariaLabel: _propTypes.default.string,

  /**
   Required. Sets the step in the progress indicator flow
   */
  currentStep: _customPropTypes.default.isRequired,

  /**
   Required. Adds a set number of steps to the progress indicator
   */
  totalSteps: _propTypes.default.number.isRequired,

  /**
   Optional, but recommended. Gives a unique identifier to the element which is useful for testing scenarios.
   */
  dataTestId: _propTypes.default.string
};
ProgressIndicator.defaultProps = {
  ariaLabel: null,
  dataTestId: null
};
var _default = ProgressIndicator;
exports.default = _default;